import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const OrderDetailPage = lazy(() => import('@/pages/orders/detail'));

export const Route = createFileRoute('/orders/$id')({
  component: function OrderRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <OrderDetailPage orderId={id} />
      </Suspense>
    );
  },
});
